import React, { forwardRef, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { useVisibleComponentsContext, VISIBLE_COMPONENTS_NAMES } from "../../context/VisibleComponentsContext";

export interface IStickyFooterProps extends IEditableProps, IStyledProps {
    showMobileOnly: Boolean;
    children;
}

const Video = forwardRef((props: IStickyFooterProps, ref: any) => {
    const { children, editorClassObj, className, cmsId, showMobileOnly } = props;
    const { visibleComponents } = useVisibleComponentsContext();
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        setHidden(visibleComponents.includes(VISIBLE_COMPONENTS_NAMES.HERO) || visibleComponents.includes(VISIBLE_COMPONENTS_NAMES.FOOTER))
    }, [visibleComponents])

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj, 'content', { 'd-lg-none': showMobileOnly, 'buildr': Boolean(cmsId), 'hidden': hidden})}>
            {children}
        </div>
    )
});

export default styled(Video)`
    bottom: 0;
    z-index: 9999;
    position: fixed;
    width: 100%;
    opacity: 1;
    visibility: visible;
    transition: all .2s ease-in-out;
    
    &:empty {
        min-height: 50px;
        background: white;
    }

    &.hidden {
        opacity: 0;
        visibility: hidden;
    }

    // Styles to account for buildr preview page padding
    &.buildr {
        width: calc(100% - 23rem);
    }

`;